import { useDispatch } from "react-redux"
import { useMutation } from "@tanstack/react-query"
import { Creators as ApiWrapperCreators } from "model/apiWrapper"
import { SigmaWorkbookInput } from "../types"

export function useSaveSigmaSolution(accountAlias: string, onSuccess: () => void, onError: (error: Error) => void) {
  const dispatch = useDispatch()
  const saveSolution = useMutation<unknown, Error, SigmaWorkbookInput>({
    mutationFn: (payload) => {
      return new Promise((resolve, reject) => {
        dispatch(ApiWrapperCreators.post(`/api/${accountAlias}/solutions/sigma`, payload, resolve, reject))
      })
    },
    onSuccess: onSuccess,
    onError: onError,
  })
  return saveSolution
}
